// Shared execution-posture labels for Evaluate ↔ Execute consistency (DMD-1201).
// BigQuery stores Evaluate "monitor" as wire value "scale"; UI must always say Monitor.

import type { InitiativeShortlistBucket } from '../contexts/EAContext';

export const EXECUTION_POSTURE_LABELS: Record<string, string> = {
  launch_now: 'Launch Now',
  launch: 'Launch Now',
  pilot: 'Pilot',
  scale: 'Monitor',
  monitor: 'Monitor',
  defer: 'Defer',
};

const SHORTLIST_LABELS: Record<InitiativeShortlistBucket, string> = {
  launch: 'Launch Now',
  pilot: 'Pilot',
  monitor: 'Monitor',
  defer: 'Defer',
};

/** Normalize raw BQ / API posture (incl. scale alias) to the Evaluate display label. */
export function formatExecutionPostureLabel(raw: string | null | undefined): string | null {
  if (raw == null) return null;
  const trimmed = String(raw).trim();
  if (!trimmed) return null;
  const normalized = trimmed.toLowerCase().replace(/[\s-]+/g, '_');
  return EXECUTION_POSTURE_LABELS[normalized] ?? trimmed;
}

/** Resolve Evaluate Initiative Shortlist posture label for a use-case id. */
export function shortlistPostureLabel(
  id: string,
  buckets: Record<InitiativeShortlistBucket, Set<string>>,
): string | null {
  const sid = String(id);
  const inBucket = (bucket: Set<string>) =>
    bucket.has(sid) || Array.from(bucket).some((existing) => String(existing) === sid);

  if (inBucket(buckets.launch)) return SHORTLIST_LABELS.launch;
  if (inBucket(buckets.pilot)) return SHORTLIST_LABELS.pilot;
  if (inBucket(buckets.monitor)) return SHORTLIST_LABELS.monitor;
  if (inBucket(buckets.defer)) return SHORTLIST_LABELS.defer;
  return null;
}
